import WidgetHostConfigPagingResultModelBase from '../_generated/modelBases/widget-host-config-paging-result-model-base';

export default class WidgetHostConfigPagingResultModel extends WidgetHostConfigPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
